// ----------------------------------------------------------------------
// <copyright file="Izenda.UserAccountDataFetcher.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

import fetch from 'share/fetch/Izenda.Fetch';

const ROOT_URL = 'user/';

export default {
  /**
   * Load user account
   * @param  {string} tenantId
   * @param  {object} pageInfo
   * @returns {Promise}
   */
  loadAllUserAccounts(tenantId, pageInfo, limitData, userModeType) {
    pageInfo = pageInfo || {};

    const requestData = {
      userModeType,
      searchByRole: limitData,
      tenantId,
      criteria: pageInfo.searchCriteria || [],
      pageIndex: pageInfo.pageIndex || 1,
      pageSize: pageInfo.pageSize || 10,
      sortOrders: pageInfo.sortOrders || [
        {
          key: 'userName',
          descending: true
        }
      ]
    };

    return fetch(`${ROOT_URL}load`).post(requestData);
  },

  /**
   * generate Password Link
   * @param  {object} data
   * @return {promise}
   */
  generatePasswordLink(data) {
    return fetch(`${ROOT_URL}generatePasswordLink`).post(data);
  },

  /**
   * activate User
   * @param  {object} data
   * @return {boolean}
   */
  activateUser(data) {
    return fetch(`${ROOT_URL}active/`).post(data);
  },

  /**
   * deactivate User
   * @param  {object} data
   * @return {boolean}
   */
  deactivateUser(data) {
    return fetch(`${ROOT_URL}deactive/`).post(data);
  },

  /**
   * save user set up detail
   * @param  {object} data
   * @return {promise}
   */
  save(data) {
    data = data || {};
    return fetch(ROOT_URL).post(data);
  },

  /**
   * delete user set up detail
   * @param  {string} userId
   * @return {boolean}
   */
  deleteUser(userId) {
    userId = userId || '';
    return fetch(ROOT_URL + userId).delete();
  },

  /**
   * save Password Options
   * @param  {object} data
   * @return {promise}
   */
  savePasswordOptions(data) {
    data = data || {};
    return fetch(`${ROOT_URL}sendPasswordLink`).post(data);
  },

  /**
   * Validate expiration of password link.
   * @param  {String} data
   */
  validateExpirationPasswordLink(data) {
    return fetch(`${ROOT_URL}validateExpirationPasswordLink`).post(data);
  },

  /**
   * Validate password link.
   * @param  {Object} data
   */
  validatePasswordLink(data) {
    return fetch(`${ROOT_URL}validatePasswordLink`).post(data);
  },

  /**
   * Validate password link.
   * @param  {Object} data
   */
  validateUserInfo(data) {
    return fetch(`${ROOT_URL}validateUserInfo`).post(data);
  },

  /**
   * Active account.
   * @param  {Object} data
   */
  passwordAndSecurityQuestion(data) {
    return fetch(`${ROOT_URL}passwordAndSecurityQuestion`).post(data);
  },

  /**
   * Login.
   * @param  {Object} data
   */
  login(data) {
    return fetch(`${ROOT_URL}login`, {
      excludeAuthHeader: true
    }).post(data);
  },

  /**
   * Logout.
   */
  logout() {
    return fetch(`${ROOT_URL}logout`).post();
  },

  /**
   * Fetch security questions of user.
   * @param  {Object} data
   */
  securityQuestion(data) {
    let uri = `securityQuestion/${data.userName}`;
    if (data.tenantDisplayID) {
      uri += `/${data.tenantDisplayID}`;
    }
    return fetch(ROOT_URL + uri).get();
  },

  /**
   * Validate security questions of user.
   * @param  {Object} data
   */
  validateSecurityQuestion(data) {
    return fetch(`${ROOT_URL}validateSecurityQuestion`).post(data);
  },

  /**
   * Update password info of user.
   * @param  {Object} data
   */
  password(data) {
    return fetch(`${ROOT_URL}password`).post(data);
  },

  /**
   * Load information of current user.
   */
  loadCurrentUser() {
    return fetch(ROOT_URL).get();
  },

  /**
   * Load all user sharing
   * @param  {object} requestData
   * @return {Promise}
   */
  loadAllowedSharingUsers(requestData) {
    return fetch(`${ROOT_URL}allowedSharingUsers/`).post(requestData);
  },

  /**
   * save user set up detail
   * @param  {object} data
   * @return {promise}
   */
  saveUserProfile(data) {
    data = data || {};
    return fetch(`${ROOT_URL}userProfile`).post(data);
  },

  /**
   * Update new password
   * @param  {object} data
   * @return {promise}
   */
  updateNewPassword(data) {
    data = data || {};
    return fetch(`${ROOT_URL}passwordProfile`).post(data);
  },

  /**
   * Validate User Role Association
   * @param  {object} data
   * @return {promise}
   */
  validateUserRoleAssociation(data) {
    data = data || {};
    return fetch(`${ROOT_URL}validateUserRoleAssociation`).post(data);
  },

  /**
   * Update new password
   * @param  {object} data
   * @return {promise}
   */
  updateSecurityQuesitions(data) {
    data = data || {};
    return fetch(`${ROOT_URL}securityQuesitions`).post(data);
  },

  /**
   * check this is the Last System Admin or not
   * @return {promise}
   */
  checkLastSystemAdmin() {
    return fetch(`${ROOT_URL}isLastSystemAdmin`).get();
  }
};



// WEBPACK FOOTER //
// ./ui/fetchers/Izenda.UserAccountDataFetcher.js